/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteSprintGoalInput = {|
  id: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type DeleteSprintGoalMutationVariables = {|
  input: DeleteSprintGoalInput
|};
export type DeleteSprintGoalMutationResponse = {|
  +deleteSprintGoal: ?{|
    +deletedSprintGoalId: ?string
  |}
|};
export type DeleteSprintGoalMutation = {|
  variables: DeleteSprintGoalMutationVariables,
  response: DeleteSprintGoalMutationResponse,
|};
*/


/*
mutation DeleteSprintGoalMutation(
  $input: DeleteSprintGoalInput!
) {
  deleteSprintGoal(input: $input) {
    deletedSprintGoalId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteSprintGoalInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSprintGoalPayload",
    "kind": "LinkedField",
    "name": "deleteSprintGoal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSprintGoalId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSprintGoalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteSprintGoalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteSprintGoalMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSprintGoalMutation(\n  $input: DeleteSprintGoalInput!\n) {\n  deleteSprintGoal(input: $input) {\n    deletedSprintGoalId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7a15d43aafe08091b14070ce1d097112';

module.exports = node;
